












































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { userData, db } from '../main';
import Challenge from '../entities/Challenge';
import Axios from 'axios';
import { functionsBaseUrl } from '../globals';
import Challenges from './Challenges.vue';

@Component
export default class CreateChallenge extends Vue {
    externalCid: string = '';
    challenge: Challenge = new Challenge();

    async saveChallange() {
        this.challenge.activities = this.selectedActivities;
        this.challenge.uid = userData.user.uid;
        try {
            if(this.challenge.id) {
                await db.collection('challenges')
                    .doc(this.challenge.id)
                    .set(this.challenge.toPOCO());
            }
            else {
                await db.collection('challenges')
                    .doc()
                    .set(this.challenge.toPOCO());
            }
            this.$toast.open('Utmaning skapad');
        }
        catch(e) {
            this.$toast.open({ 
                message: 'Utmaning kunde inte skapas', 
                type: 'is-danger'
            });
        }
    }

    availableActivities: any[] = [];

    get selectedActivities() {
        return this.availableActivities.filter(x => !x.deselected).map(x => x.id);
    }

    private async getChallenge() {
        const available = await userData.loadChallenges();
        const c = available.find(x => x.id === this.externalCid);
        this.challenge = c ? c : new Challenge();
    }

    private async getActivities() {
        const urls = await Axios.get(functionsBaseUrl + "activities");
        const acts = urls.data.map(a => {
            if(this.challenge.activities)
                a.deselected = !this.challenge.activities.some(aid => aid === a.id );
            else
                a.deselected = true;
            return a;
        });
        acts.sort((a, b) => {
            const textA = a.text.toUpperCase();
            const textB = b.text.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });

        this.availableActivities = acts;
    }

    public async beforeMount() {
        this.externalCid = this.$route.params.cid;
        this.getChallenge().then(() => {
            this.getActivities();
        });
    }
}
